export const environment = {
    production: 'true',
    appBaseHref: '/',
    oidc: {
      clientId: '0oa6aeaqg33wYun0i4h7',
      issuer: 'https://relayhealth.okta.com/oauth2/aus6a5yiuiwuMMlZD4h7',
      redirectUri: 'login/callback',
      scopes: ['openid'],
      pkce: false
    },
    resourceServer: {
      messagesUrl: ''
    },
    transactionListUrl: 'https://rxosupport-api.relayhealth.com/transaction-list',
    transactionLookupUrl:'https://rxosupport-api.relayhealth.com/transaction-lookup',
    pharmacyCrudUrl:'https://rxosupport-api.relayhealth.com/pharmacy-crud',
    pharmacyListUrl:'https://rxosupport-api.relayhealth.com/pharmacy-list',
    pharmacyLookupUrl:'https://rxosupport-api.relayhealth.com/pharmacy-lookup',
    pharmacyStoresCrudUrl:'https://rxosupport-api.relayhealth.com/pharmacy-stores-crud',
    configUIAPIUrl:'https://rxosupport-api.relayhealth.com/config-ui-api',
    testConnectivityUrl:'https://rxosupport-api.relayhealth.com/config-ui-api/testconnectivity'
  };
  